import { AppJoyride } from "@/shared/ui/AppJoyride";
import { usersTourSteps } from "./tourSteps";

type UsersTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function UsersTour({ run, onCallback }: UsersTourProps) {
  return (
    <AppJoyride steps={usersTourSteps} run={run} onCallback={onCallback} />
  );
}

export { useUsersTour } from "./useUsersTour";
